<script>
import { nextTick } from 'vue'
import util from './utils/util.js'
import permissionListener from '@/utils/authorize/permissionListener.js'
import { getPlatformDetail, getPlatformDetailUrl, getPaySettlementTypeConfig, getTidAppId } from '@/api/modules/mall4cloud_admin.js'
import { loginByWechatMa } from '@/api/modules/mall4cloud_auth.js'
import { handleRequestError } from '@/api/error.js'
export default {
  onLaunch: async function () {
    // 设置应用类型
    util.setAppType()
    // #ifdef APP-PLUS
    // APP模式下保持竖屏
    // eslint-disable-next-line no-console
    console.log('mall4j.v240507')
    // eslint-disable-next-line no-undef
    plus.screen.lockOrientation('portrait-primary')
    // #endif
    // #ifdef H5
    const domain = util.getDomain()
    const StorageSynDomain = uni.getStorageSync(domain)
      const domainAddress = import.meta.env.VITE_APP_DOMAIN_ADDRESS
      if (!StorageSynDomain && window.location.href.indexOf(domainAddress) !== 0) {
        try {
        const data = await getTidAppId({
          data: {
            url: domain,
            fromType: 3
          }
        })
        uni.setStorageSync(domain, data.tid)
        uni.setStorageSync('cloudMpAppId', data.mpAppId)
      } catch (error) {
        handleRequestError(error)
      }
    }
    try {
      const data = await getPlatformDetail({})
      nextTick(() => {
        const pages = getCurrentPages()
        const currentPage = pages[pages.length - 1]?.route
        if (data.platformStatus === 1 && currentPage === 'pages/mall-offline/mall-offline') {
          uni.switchTab({
            url: '/pages/index/index'
          })
        } else if (data.platformStatus !== 1) {
          uni.navigateTo({
            url: '/pages/mall-offline/mall-offline' + (uni.getStorageSync(domain) ? '' : '?tid=' + uni.getStorageSync('cloudTid'))
          })
        }
      })
    } catch (error) {
      handleRequestError(error)
    }
    let url = ''
    const tid = uni.getStorageSync('cloudTid')
    uni.addInterceptor('switchTab', {
      invoke (e) {
        url = e.url
      },
      complete () {
        if (url === '/') {
          // 在首页添加参数
          uni.reLaunch({
            url: '/pages/index/index' + (uni.getStorageSync(domain) ? '' : '?tid=' + tid)
          })
        } else {
          uni.reLaunch({
            url: url + (uni.getStorageSync(domain) ? '' : '?tid=' + tid)
          })
        }
      }
    })
    uni.getSystemInfo({
      success: function (res) {
        // 客户端平台，值域为：ios、android
        if (res.platform === 'ios') {
          uni.setStorageSync('cloudIosUrl', window.location.href.split('#')[0])
        }
      }
    })
    // #endif

    // #ifdef MP-WEIXIN
    // 检查小程序版本
    this.checkMiniUpdate()
    // #endif
    // 进入应用时清除重定向地址
    uni.removeStorageSync('cloudRouteUrlAfterLogin')
    // 进入应用时清除地区缓存
    uni.removeStorageSync('cloudProvArray')
    // 微信环境统一登录方法
    util.weChatLogin()
    nextTick(async () => {
      // 获取网站配置
      useWebConfigStore().getUniWebConfig()

      // 获取并更新通联支付配置
      const params = {}
      try {
        const res = await getPaySettlementTypeConfig(params)
        if (res) {
          uni.setStorageSync('cloudPaySettlementType', JSON.parse(res).paySettlementType || 0)
        }
      } catch (error) {
        handleRequestError(error)
      }
    })
    uni.getSystemInfo({
      success: function (res) {
        // px转换到rpx的比例
        const pxToRpxScale = 750 / res.windowWidth
        const systems = {
          ktxStatusHeight: res.statusBarHeight * pxToRpxScale,
          // 状态栏的高度
          navigationHeight: 44 * pxToRpxScale,
          // 导航栏的高度
          ktxWindowWidth: res.windowWidth * pxToRpxScale,
          // window的宽度
          ktxWindowHeight: res.windowHeight * pxToRpxScale,
          // window的高度
          ktxScreentHeight: res.screenHeight * pxToRpxScale // 屏幕的高度
        }
        provide('$system', systems)
        provide('$lineHeight', systems.ktxStatusHeight + systems.navigationHeight)
      }
    })
    setTimeout(async () => {
      try {
        const data = await getPlatformDetailUrl({})
        const currentUrl = data.h5Url
        const urlParts = currentUrl.split('?')
        const host = urlParts[0]
        data.h5Url = host
        uni.setStorageSync('cloudAppDetailUrl', data)
      } catch (error) {
        handleRequestError(error)
      }
    }, 3000)
  },
  onShow: async function (options) {
    permissionListener?.listenerFunc()
    // #ifdef MP-WEIXIN
    console.log('接收到的参数', options.referrerInfo.extraData)
    // 中瑞商圈传递的登录参数需要用商圈账号做自动登录
    if (options.referrerInfo && options.referrerInfo.extraData) {
      const { phone, ticket } = options.referrerInfo.extraData
      // 获取用户缓存信息
      const userInfo = uni.getStorageSync('cloudUserDetails')
      const maLogin = () => {
        const params = {
          data: {
            ticket
          }
        }
        uni.showLoading({
          title: '登录中...'
        })
        setTimeout(() => {
          loginByWechatMa(params).then((res) => {
            const hiddenPhone = phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
            util.loginSuccess(res.tokenInfo ? res.tokenInfo : res)
            uni.showToast({
              title: `账号 ${hiddenPhone} 登录成功~`,
              icon: 'none'
            })
            setTimeout(() => {
              uni.hideLoading()
            }, 1500)
          }).catch((err) => {
            console.log('err===', err)
            uni.hideLoading()
            this.__mpReferrerLoginHandled = true
            this.onLoginErrHandle(err)
          })
        }, 1500)
      }
      if (phone && ticket && !this.__mpReferrerLoginHandled) {
        if (!userInfo) {
          maLogin()
        } else if (userInfo.phone !== phone) {
          const hiddenPhone = phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
          uni.showModal({
            title: '提示',
            content: `检测到当前账号与商圈登录账号不一致，是否使用 ${hiddenPhone} 账号重新登录？`,
            success: function (res) {
              if (res.confirm) {
                maLogin()
              }
              if (res.cancel) {
                this.__mpReferrerLoginHandled = false
              }
            }
          })
        }
      }
    }
    // 通联支付从通联微信小程序返回后接收的参数
    if (uni.getStorageSync('cloudPaySettlementType') !== 1) {
      // 非通联支付模式下不处理
      return
    }
    if (options.referrerInfo && options.referrerInfo.extraData) {
      let backMerchantUrl = options.referrerInfo.extraData.backMerchantUrl
      if (backMerchantUrl) {
        backMerchantUrl = decodeURIComponent(backMerchantUrl)
        const result = backMerchantUrl.split('?')[1].split('&')
        const query = {}
        for (let i = 0; i < result.length; i++) {
          const item = result[i].split('=')
          query[item[0]] = item[1]
        }
        if (Number(query.isSignSuccess) === 1 && query.bizContent) {
          // 获取内存中的签约编号
          const acctProtocolNo = uni.getStorageSync('cloudAllinpayAcctProtocolNo')
          const bizContent = JSON.parse(decodeURIComponent(query.bizContent))
          if (bizContent.acctProtocolNo !== acctProtocolNo) {
            uni.showToast({
              title: '签约成功',
              icon: 'none'
            })
            uni.setStorageSync('cloudAllinpayAcctProtocolNo', bizContent.acctProtocolNo)
          }
        } else if (Number(query.isSignSuccess) === 0) {
          uni.showToast({
            title: '签约失败',
            icon: 'none'
          })
        }
      }
    }
    // #endif
    // #ifdef APP-PLUS
    // 通联支付从通联APP返回后接收的参数
    // eslint-disable-next-line no-undef
    const args = plus.runtime.arguments
    if (args) {
      // 处理args参数的逻辑代码，如直达到某新页面等
      if (uni.getStorageSync('cloudPaySettlementType') !== 1) {
        // 非通联支付模式下不处理
        return
      }
      const result = args.split('?')[1].split('&')
      const query = {}
      for (let i = 0; i < result.length; i++) {
        const item = result[i].split('=')
        query[item[0]] = item[1]
      }
      if (query.isBuyVip === '0' || query.isBuyVip === '1') {
        // 如果是购买会员，则跳转到会员中心
        uni.navigateTo({
          url: '/package-activities/pages/member-center/member-center'
        })
      } else if (query.isFlashOrderEntry === '0' || query.isFlashOrderEntry === '1') {
        uni.navigateTo({
          url: '/package-user/pages/flash-order/flash-order?type=all'
        })
      }
      // eslint-disable-next-line no-undef
      plus.runtime.arguments = '' // 清空参数防止多次进入
    }
    // #endif
    // 设置语言
    uni.setLocale('zh-Hans')
  },
  onHide: function () {
    permissionListener?.stopFunc()
  },
  // 页面不存在时触发
  onPageNotFound: function () {
    uni.reLaunch({
      url: '/pages/index/index'
    })
  },
  globalData: {
    // 定义全局请求队列
    requestQueue: [],
    // 可中断的请求队列
    requestAbortQueue: [],
    // 埋点请求队列
    flowRequestQueue: [],
    // 是否正在进行登录
    isLanding: false,
    // 购物车商品数量
    totalCartCount: 0,
    // 当前请求数量
    currentReqCounts: 0,
    // 设备信息
    sysInfo: {},
    reloadHomePopupAd: true,
    // 是否重新加载首页弹窗
    reloadPageData: false // 是否重新加载页面数据
  },
  methods: {
    /**
     * 微信小程序检查升级
     */
    checkMiniUpdate () {
      const updateManager = wx.getUpdateManager()
      updateManager.onUpdateReady(function () {
        wx.showModal({
          title: '更新提示',
          content: '新版本已经准备好，是否重启应用？',
          success: function (res) {
            if (res.confirm) {
              // 新的版本已经下载好，调用 applyUpdate 应用新版本并重启
              updateManager.applyUpdate()
            }
          }
        })
      })
      updateManager.onUpdateFailed(function () {
        // 新版本下载失败
        uni.showToast({
          title: '新版本下载失败,请重试',
          duration: 2000,
          icon: 'none'
        })
      })
    },

    /**
     * 登录异常
    */
    onLoginErrHandle (err) {
      if (err.code === 'A00001' || err.code === 'A00005' || err.code === 'A00006') {
        uni.showToast({
          title: err.msg || 'Error',
          icon: 'none'
        })
      }
      if (err.code === 'A00012') {
        // 还原全局 正在登录状态
        util.resetLoginSts()
        // tempUid 错误，重新获取
        uni.removeStorageSync('cloudTempUidCloud')
        uni.showModal({
          showCancel: false,
          title: $t('userLogin.tips'),
          content: $t('userLogin.codeErrorTips'),
          confirmText: $t('userLogin.confirm'),
          success: res => {
            if (res.confirm) {
              // #ifdef H5
              window.history.replaceState({}, '', window.location.href.split('?')[0])
              // #endif
              util.weChatLogin()
            }
          }
        })
      }
      if (err.code === 'A04002') {
        // 弹窗
        uni.showModal({
          showCancel: false,
          title: $t('userLogin.bindedTipsTit'),
          content: $t('userLogin.bindedTipsCon'),
          confirmText: $t('userLogin.bindedTipsBtn'),
          confirmColor: '#E43130'
        })
      }
    }
  }
}
</script>
<!-- eslint-disable-next-line vue-scoped-css/enforce-style-type -->
<style lang="scss">
@import "nutui-uniapp/styles/mixins/index.scss";
/* #ifndef MP-WEIXIN */
@import "nutui-uniapp/styles/index.scss";
/* #endif */

:root,
page {
  --nut-price-symbol-small-size: 18rpx;
  --nut-price-small-size: 24rpx;
  --nut-price-decimal-small-size: 20rpx;
  --nut-price-symbol-medium-size: 22rpx;
  --nut-price-medium-size: 32rpx;
  --nut-price-decimal-medium-size: 24rpx;
  --nut-price-symbol-big-size: 28rpx;
  --nut-price-big-size: 48rpx;
  --nut-price-decimal-big-size: 32rpx;
}

.nut-price {
  --nut-primary-color: currentColor;
}

/* #ifndef APP-PLUS-NVUE */
@import url("./app.css");
/* #endif */
</style>
